import React from "react";
import {Box, Grid, Icon, Stack, Text} from "@mbank-design/design-system/components";
import {CalendarColor} from "@mbank-design/design-system/icons";

export default function SpeakerInvitationDaysHeader() {
    return (
        <Stack>
            <Text as="h2">attending</Text>
            <Box>
                <Grid>
                    <Grid.Row>
                        <Grid.Column span={1}>
                            <Icon iconComponent={CalendarColor} size={24}/>
                        </Grid.Column>
                        <Grid.Column span={11}>
                            <Text fontFamily="Montserrat" lineClamp={4}>please indicate which sessions you would like to attend and whether you will be attending "in person" or "virtually"</Text>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </Box>
        </Stack>
    );
}